import React from "react";
import { Card } from "../cards/Card";
import { Button } from "../buttons/Button";
import "./InvestmentType.scss";
export var InvestmentType;
(function (InvestmentType) {
    InvestmentType["BROAD"] = "BROAD";
    InvestmentType["SUSTAINABLE"] = "SUSTAINABLE";
})(InvestmentType || (InvestmentType = {}));
export const InvestmentTypeSE = ({ onChange, disabled, isCompany, }) => (React.createElement("div", { className: "lysa-ui-investment-type" },
    React.createElement(Card, null,
        React.createElement("h2", null, "Bred"),
        React.createElement("ul", null,
            React.createElement("li", null, "Fokus p\u00E5 maximal riskspridning och global exponering."),
            React.createElement("li", null,
                isCompany ? "Företagets" : "Dina",
                " pengar f\u00F6rvaltas i fler \u00E4n 6 000 aktiebolag och 5 000 r\u00E4nteinstrument.")),
        React.createElement(Button, { block: true, onClick: () => onChange(InvestmentType.BROAD), disabled: disabled, variant: "primary", size: "medium", label: "V\u00E4lj bred inriktning" })),
    React.createElement(Card, null,
        React.createElement("h2", null, "H\u00E5llbar"),
        React.createElement("ul", null,
            React.createElement("li", null, "Exkluderar bolag som \u00E4r verksamma inom spel, vapen, droger och fossila br\u00E4nslen."),
            React.createElement("li", null,
                isCompany ? "Företagets" : "Dina",
                " pengar f\u00F6rvaltas i ca 1000 aktiebolag och 140 r\u00E4nteinstrument med aktivt samh\u00E4lls- och milj\u00F6ansvar.")),
        React.createElement(Button, { block: true, onClick: () => onChange(InvestmentType.SUSTAINABLE), disabled: disabled, variant: "primary", size: "medium", label: "V\u00E4lj h\u00E5llbar inriktning" }))));
